import { ROLE } from "../data/enums";

export const OUTSOURCE_ORDER_CREATE_ROLES: ROLE[] = [
    ROLE.MANAGER,
    ROLE.LOGISTIC_STAFF,
    ROLE.PURCHASING_STAFF,
];

export const OUTSOURCE_ORDER_EXPORT_ROLES: ROLE[] = [
    ROLE.MANAGER,
    ROLE.STORAGE_KEEPER,
    ROLE.FIRST_STORAGE_KEEPER,
    ROLE.SECOND_STORAGE_KEEPER,
];
